import React from 'react'

interface MultiChoiceDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MultiChoiceDT: React.FC<MultiChoiceDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M9.16699 16.25H17.5003" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.16699 10.418H17.5003" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.16699 4.58203H17.5003" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 4.58464L3.33333 5.41797L5.83333 2.91797" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 10.4167L3.33333 11.25L5.83333 8.75" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 16.2487L3.33333 17.082L5.83333 14.582" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default MultiChoiceDT
